export const DATE_FORMAT = 'YYYY.MM.DD';
export const DATE_FORMAT_FULL = 'YYYY.MM.DD hh:mm';
